import { lazy } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'

const Inner = lazy(() => import('./Inner'))

/**
 * Hosts the billing dialogs that may be invoked from anywhere else in the app.
 */
export const BillingDialogsHost = observer(function BillingDialogsHost() {
  const { isBillingRequested } = useFeatures((r) => ({
    isBillingRequested: r.billing.internal.isRequested,
  }))

  // Rendering the dialogs loads the feature, so wait until something else has.
  if (!isBillingRequested()) {
    return null
  }

  return <Inner />
})
